/* eslint-disable */
/**
 * Auto generated version file, do not modify it!
 */
const version = '1.28.1';
export { version };
//# sourceMappingURL=version.js.map